import React, { memo, useRef, useEffect, useState, useImperativeHandle } from "react";
import { Form, Input, Button } from "antd";

export default memo((props) => {
  const { value = {}, onValueChange, stopEditing } = props;
  const [form] = Form.useForm();
  const refContainer = useRef(null);

  useImperativeHandle(props.forwardedRef, () => ({
    getValue: () => {
      return form.getFieldsValue();
    },
    isPopup: () => true,
    afterGuiAttached: () => {
      setTimeout(() => {
        refContainer.current?.focus();
      });
    }
  }));

  useEffect(() => {
    if (value) {
      form.setFieldsValue(value);
    }
  }, [value, form]);

  const handleSave = async () => {
    try {
      const address = await form.validateFields();
      if (onValueChange) {
        onValueChange(address);
      }
      stopEditing && stopEditing();
    } catch (err) {
      // Validation failed, do nothing
    }
  };

  const handleCancel = () => {
    stopEditing && stopEditing(true);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        handleCancel();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <div
      ref={refContainer}
      tabIndex={0}
      style={{
        background: "white",
        border: "1px solid #ccc",
        borderRadius: 8,
        padding: 8,
        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
        width: "170%",
        fontSize: 12,
        zIndex: 9999,
        boxSizing: "border-box"
      }}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={value}
        style={{ marginBottom: 0 }}
      >
        <Form.Item name="street" label="Street" style={{ marginBottom: 6, fontSize: 12 }}>
          <Input size="small" style={{ fontSize: 12 }} autoFocus />
        </Form.Item>
        <Form.Item name="city" label="City" style={{ marginBottom: 6, fontSize: 12 }}>
          <Input size="small" style={{ fontSize: 12 }} />
        </Form.Item>
        <Form.Item name="state" label="State" style={{ marginBottom: 6, fontSize: 12 }}>
          <Input size="small" style={{ fontSize: 12 }} />
        </Form.Item>
        <Form.Item name="country" label="Country" style={{ marginBottom: 6, fontSize: 12 }}>
          <Input size="small" style={{ fontSize: 12 }} />
        </Form.Item>
        <Form.Item name="postal_code" label="Postal Code" style={{ marginBottom: 6, fontSize: 12 }}>
          <Input size="small" style={{ fontSize: 12 }} />
        </Form.Item>
      </Form>
      <div style={{ display: "flex", justifyContent: "flex-end", gap: 6 }}>
        <Button size="small" style={{ fontSize: 12 }} onClick={handleCancel}>
          Cancel
        </Button>
        <Button size="small" type="primary" style={{ fontSize: 12 }} onClick={handleSave}>
          OK
        </Button>
      </div>
    </div>
  );
});
